import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_OPERATORS = "SET_OPERATORS";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_SALES = "SET_SALES";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setOperators(operators) {
  return {
    type: SET_OPERATORS,
    payload: operators,
  };
}

function setSales(sales) {
  return {
    type: SET_SALES,
    payload: sales,
  };
}

function setCustomers(customers) {
  return {
    type: SET_CUSTOMERS,
    payload: customers,
  };
}


// Accounts of a role, loaded by pages of 100 (API maximum)
async function fetchAllAccounts(token, role) {
  const limit = 100;
  const accounts = [];
  let total = Infinity;

  for (let page = 1; accounts.length < total && page <= 50; page += 1) {
    const response = await axios.get(
      `${HOST_URL}/accounts?role=${role}&page=${page}&limit=${limit}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data.data || [];

    accounts.push(...data);
    total = response.data.meta?.total ?? accounts.length;
    if (data.length < limit) break;
  }

  return accounts;
}

export function getOperators(token) {
  return async (dispatch) => {
    try {
      await dispatch(setOperators(await fetchAllAccounts(token, "operator")));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function getSales(token) {
  return async (dispatch) => {
    try {
      await dispatch(setSales(await fetchAllAccounts(token, "sales")));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function createOperator(token, userData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/accounts/admin`,
        userData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(getOperators(token));
      await callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateOperatorAccount(token, account, updateData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/accounts/admin/${account}`,
        updateData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(getOperators(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function deleteOperatorAccount(token, account, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/accounts/admin/${account}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(getOperators(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getCustomers(token) {
  return async (dispatch) => {
    try {
      const customers = await fetchAllAccounts(token, "user");

      await dispatch(
        setCustomers({
          data: customers,
          meta: { total: customers.length, page: 1, limit: customers.length },
        })
      );
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}


export function updateCustomerAccount(token, account, updateData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/accounts/${account}`,
        updateData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(getCustomers(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function deleteCustomerAccount(token, account, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${HOST_URL}/accounts/${account}`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(getCustomers(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
